import { InputProps } from "@heroui/react";
import { useMemo, useRef, useState } from "react";

// custom hook until HeroUI implements counter https://github.com/heroui-inc/heroui/issues/3545
export function useHandleInputValueChange({
  defaultValue,
  maxLength,
  onValueChange,
  value,
}: Pick<InputProps, "defaultValue" | "value" | "maxLength" | "onValueChange">) {
  const initialLen = useMemo(() => {
    if (typeof value === "string") return value.length;
    if (typeof defaultValue === "string") return defaultValue.length;
    return 0;
  }, [value, defaultValue]);

  const [valueLength, setValueLength] = useState<number>(initialLen);

  const handleValueChange = (next: string) => {
    if (maxLength) {
      if (next.length > maxLength) {
        return;
      }
      setValueLength(next.length);
    }
    onValueChange?.(next);
  };

  return {
    handleValueChange,
    valueLength,
  };
}

// custom component until HeroUI implements counter https://github.com/heroui-inc/heroui/issues/3545
export function CounterRow({
  left,
  maxLength,
  value,
  valueLength,
}: {
  left?: React.ReactNode;
  maxLength?: number;
  value?: string;
  valueLength?: number;
}) {
  const isControlled = useRef(value != null).current;

  if (!maxLength) {
    return left ? <div>{left}</div> : null;
  }

  const count = isControlled ? value?.length ?? 0 : valueLength ?? 0;

  return (
    <span className="flex w-full items-center justify-between">
      <span>{left}</span>
      <span>
        {count}/{maxLength}
      </span>
    </span>
  );
}
